import { ApiRemoteUpdate } from './infrastructure/services/api-remote-update';
import { API_OPTIONS_TOKEN } from './infrastructure/tokens/shared-tokens';
import { API_OPTIONS } from './infrastructure/types/api-options';

export function provideRemoteUpdateDomain(options: API_OPTIONS) {
  return [
    ApiRemoteUpdate,
    {
      provide: API_OPTIONS_TOKEN,
      useValue: options
    }
  ];
}
